import React, { useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { useState } from "react";

// css
import styles from "../../../layout/Auth/Auth.module.scss";
import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { useActivateAccountMutation, useForgotPasswordMutation, useVerifyActivationTokenQuery } from "store/services/auth";
import LoadingButton from "components/shared/LoadingButton";
import { LOGIN } from "config/paths";
import { EyeCloseIcon, EyeOpenIcon, PadLockIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import { successMessageToast } from "helpers/common";

import {
  confirmPasswordSchema,
  createPasswordSchema,
  emailSchema
} from "utils/validation/validationHelpers";

import { object } from "yup";

const activateAccountSchema = object().shape({
  email: emailSchema,
  password: createPasswordSchema,
  confirm_password: confirmPasswordSchema("password")
});


const ActivateAccount = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  
  const [showPassword, setShowPassword] = useState({pwd: false, confirm_pwd: false});

  const { data: verificationResult, isLoading, isError } = useVerifyActivationTokenQuery(token, { skip: !token });
  const [activateAccountSubmit, { isLoading: activateAccountLoading }] = useActivateAccountMutation();

  if (isError === true) {
    navigate(LOGIN)
  }

  const initialValues = useMemo(() => {
    if (!verificationResult) {
      return {};
    }

    return ({
      email: verificationResult?.email,
      username: verificationResult?.username,
    })
  }, [verificationResult])

  const toggleShowPassword = (field) => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSubmit = async (values) => {
    try {
      const result = await activateAccountSubmit({
        payload: {
          username: values.username,
          password: values.password,
        },
        token
      }).unwrap();

      successMessageToast(result?.message)

      navigate(LOGIN);
    } catch (err) {
      console.error("Error in ActivateAccount:", err);
    }
  }

  return (
    <>
      <div className="formInner position-relative px-lg-3">
        <div className="w-100 inner">
          <div className="top py-2 text-center">
            <h4 className="m-0 fw-bold py-1">Set Your Password</h4>
          </div>
          {isLoading ? (
            <LoadingIndicator />
          ) : isError ? (
            <ErrorComponent />
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={activateAccountSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({
                handleSubmit,
                isSubmitting,
              }) => (
                <Form className={`${styles.form} pt-2`} onSubmit={handleSubmit}>
                  <Row className="justify-content-center">
                    {/* <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Username:
                      </label>
                      <AppInputField
                        name="username"
                        placeholder="john"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col> */}
                    <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Email address:
                      </label>
                      <AppInputField
                        name="email"
                        placeholder="john******@gmail.com"
                        className={`${styles.formControl} form-control`}
                        disabled
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Password
                      </label>
                      <div className="position-relative iconWithText">
                        <AppInputField
                          type={showPassword.pwd ? "text" : "password"}
                          className={`${styles.formControl} form-control`}
                          placeholder="*************"
                          name="password"
                        />
                        <Button
                          onClick={() => toggleShowPassword("pwd")}
                          className="border-0 p-0 position-absolute icn"
                          variant="transparent"
                          style={{ right: 10 }}
                        >
                          {showPassword.pwd ? <EyeOpenIcon /> : <EyeCloseIcon />}
                        </Button>
                      </div>
                    </Col>
                     <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 pb-1 text-muted fw-sbold"
                      >
                        Confirm Password
                      </label>
                      <div className="position-relative iconWithText">
                        <AppInputField
                          type={showPassword.confirm_pwd ? "text" : "password"}
                          className={`${styles.formControl} form-control`}
                          placeholder="*************"
                          name="confirm_password"
                        />
                        <Button
                          onClick={() => toggleShowPassword("confirm_pwd")}
                          className="border-0 p-0 position-absolute icn"
                          variant="transparent"
                          style={{ right: 10 }}
                        >
                          {showPassword.confirm_pwd ? <EyeOpenIcon /> : <EyeCloseIcon />}
                        </Button>
                      </div>
                    </Col>
                    {/* <Col lg="12" className="my-2">
                    <label
                      htmlFor=""
                      className="form-label m-0 pb-1 text-muted fw-sbold"
                    >
                      Confirm Password
                    </label>
                    <div className="position-relative iconWithText">
                      <AppInputField
                        type={showPassword ? "text" : "password"}
                        className={`${styles.formControl} form-control`}
                        placeholder="*************"
                        name="confirm_password"
                      />
                      <Button
                        onClick={toggleShowPassword}
                        className="border-0 p-0 position-absolute icn"
                        variant="transparent"
                        style={{ right: 10 }}
                      >
                        <PadLockIcon />
                      </Button>
                    </div>
                  </Col> */}
                    <Col lg="8" className="my-2">
                      <div className={`${styles.btnWrpper} pt-4 btnWrpper text-center`}>
                        <LoadingButton
                          type="submit"
                          className="d-flex align-items-center justify-content-center w-100 commonBtn"
                          isLoading={isLoading || activateAccountLoading}
                        >
                          Submit
                        </LoadingButton>
                        <Link to={LOGIN} className="mt-2 d-block themeClr">Return to Login</Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </>
  );
};
export default ActivateAccount;
